<template>
  <modal body-classes="p-0" :show="open" @close="close">
    <card type="secondary" class="border-0 mb-0">
      <template slot="header">
        <h2 class="text-center mb-0">เพิ่มโค๊ดโปรโมชั่น</h2>
      </template>
      <template>
        <form @submit.prevent="addRedeem">
          <base-input
            label="โค๊ดโปรโมชั่น"
            placeholder="โค๊ดโปรโมชั่น"
            required
            v-model="redeem.code"
          />
          <base-input
            label="จำนวนเครดิต"
            placeholder="จำนวนเครดิต"
            required
            v-model.number="redeem.amount"
          />
          <base-input
            label="จำนวนโค๊ด"
            placeholder="จำนวนโค๊ด"
            required
            v-model.number="redeem.limit"
          />
          <base-input
            label="ยอดถอนสูงสุด (เท่า)"
            placeholder="ยอดถอนสูงสุด (เท่า)"
            required
            v-model.number="redeem.maxWithdraw"
          />
          <base-input
            label="เทิร์น (เท่า)"
            placeholder="เทิร์น (เท่า)"
            required
            v-model.number="redeem.turn"
          />

          <div class="mt-1">
            <base-button
              native-type="submit"
              type="default"
              :disabled="loading"
            >
              บันทึกข้อมูล
            </base-button>
          </div>
        </form>
      </template>
    </card>
  </modal>
</template>

<script>
import { Select, Option } from "element-ui";

import RedeemService from "../../services/redeem.service";

export default {
  props: ["open"],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: false,
      redeem: {
        code: "",
        amount: 0,
        limit: 0,
        maxWithdraw: 0,
        turn: 0,
      },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addRedeem() {
      this.redeem.code.trim().toUpperCase();
      if (!this.redeem.code.match(/^[a-zA-Z0-9]+$/)) {
        this.$notify({
          type: "danger",
          message: "โค๊ดโปรโมชั่นต้องเป็นภาษาอังกฤษและตัวเลขเท่านั้น",
        });
        return false;
      }

      this.loading = true;
      RedeemService.addRedeem(this.redeem)
        .then(({ message }) => {
          this.$notify({
            type: "success",
            message: message,
          });

          this.$emit("close");
          this.$emit("reload");
        })
        .catch(({ message }) => {
          this.$notify({ type: "danger", message });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    open(v) {
      if (v) {
        this.redeem.code =
          localStorage.getItem("x-prefix").toLowerCase() +
          Math.floor(Math.random() * 1000000000);
      }
    },
  },
};
</script>
